import ScreenContent from "../../components/layout/ScreenContent";
import OffMarketPropertyListingsSection from "./OffMarketPropertyListingsSection";

const OffMarketListingsScreen = ({ children }) => {
  return <OffMarketPropertyListingsSection />;
};

export default OffMarketListingsScreen;
